import BoringAvatar from "@totem.org/solid-boring-avatars";
import { Show } from "solid-js";
import "./Avatar.css";

/** Bauhaus fallback palette — hex values from `shared-core.css` brand tokens. */
const BORING_AVATAR_GVT_THEME_COLORS: string[] = [
	"#0f6bfe", // --gvt-blue
	"#7c20b8", // --gvt-purp
	"#28c699", // --gvt-teal-green
	"#3b7fef", // --gvt-blue-400
	"#9cb8e4", // --gvt-blue-300
];

type Props = {
	src?: string;
	alt: string;
	size?: "xsmall" | "small" | "medium" | "large";
};

const SIZE_MAP = {
	xsmall: 1.5,
	small: 2,
	medium: 3,
	large: 6.5,
} as const;

const SIZE_PX = {
	xsmall: 24,
	small: 32,
	medium: 48,
	large: 104,
} as const;

/**
 * Circular avatar: photo or deterministic generated pattern from `alt`.
 *
 * [Design System →](http://localhost:5174/component/Avatar)
 */
export const Avatar = (props: Props) => {
	const sizeKey = props.size ?? "medium";
	const sizeClass = props.size ? `gvtui-avatar--${props.size}` : "";
	const boringSizePx = () => SIZE_MAP[sizeKey];
	const edgePx = () => SIZE_PX[sizeKey];
	return (
		<Show
			when={props.src}
			fallback={
				<BoringAvatar
					colors={BORING_AVATAR_GVT_THEME_COLORS}
					variant="bauhaus"
					size={boringSizePx() * 16}
					name={props.alt}
				/>
			}
		>
			<img
				class={`gvtui-avatar ${sizeClass}`}
				src={props.src}
				alt={props.alt}
				width={edgePx()}
				height={edgePx()}
				decoding="async"
			/>
		</Show>
	);
};
